module.exports = __webpack_public_path__ + "static/media/placeholder.66c6a83d.png";